import styled from 'styled-components';

import { GENERAL_COLORS } from '../../../constants/colors';
import { Text } from '../../texts';

const InputButton = styled.button`
  position: relative;
  display: flex;
  justify-content: left;
  align-items: center;
  cursor: pointer;
  pointer-events: ${(p) => (p.isDisable ? 'none' : 'auto')};
  width: 80px;
  height: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  padding-left: 5px;
  border: 1px solid
    ${(p) => (p.error ? GENERAL_COLORS.red : p.theme.color.background)};
  background-color: ${(p) => p.theme.color.background};
  transition: all ${(p) => p.theme.duration.s} ${(p) => p.theme.function.oq};

  ${Text} {
    font-size: 12px;
    color: ${(p) => (p.error ? GENERAL_COLORS.red : p.theme.color.wight)};
    overflow-x: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &:hover {
    border-color: ${(p) => (p.error ? GENERAL_COLORS.red : p.theme.color.pale)};
  }

  &:focus {
    border-color: ${(p) =>
      p.error ? GENERAL_COLORS.red : p.theme.color.turquoise};
  }

  &:active {
    transform: scale(0.95) translateY(2px);
  }
`;

export const Styled = {
  InputButton,
};
